import { Component, Input } from '@angular/core';
import { DetailPanelComponent } from '../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../core/panels/detail-panel/detail-item.component';
import { AddressLabelComponent } from '../../core/labels/address-label.component';
import { ContactPreferenceComponent } from './contact-preference.component';

@Component({
  selector: 'app-policy-agency',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    AddressLabelComponent,
    ContactPreferenceComponent,
  ],
  template: `<div class="tw-flex tw-gap-8 tw-pb-8">
      <div class="tw-basis-1/4">
        <app-detail-panel [dataSource]="dataSource" [showIcons]="false">
          <app-detail-item label="Agency Number" name="agencyNumber" />
          <app-detail-item label="Agency Name" name="agencyName" />
        </app-detail-panel>
      </div>
      <div class="tw-basis-1/4">
        <app-detail-panel [dataSource]="dataSource" [showIcons]="false">
          <app-detail-item label="Address">
            <ng-template let-data #value>
              <app-address-label
                [street1]="data.street1"
                [street2]="data.street2"
                [street3]="data.street3"
                [city]="data.city"
                [state]="data.state"
                [postalCode]="data.postalCode"
                [country]="data.country"
              />
            </ng-template>
          </app-detail-item>
        </app-detail-panel>
      </div>
      <div class="tw-basis-1/4">
        <app-detail-panel [dataSource]="dataSource" [showIcons]="false">
          <app-detail-item label="Placing Office" name="placingOffice" />
        </app-detail-panel>
      </div>
    </div>
    <app-contact-preference [dataSource]="dataSource" />`,
  styles: [],
})
export class AgencyPolicyComponent {
  @Input()
  dataSource: any;
}
